<ara-side-nav #navbar class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
<form [formGroup]="TNCForm" #tncForm="ngForm">
  <div class="page-content-wrapper">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
      <ol class="breadcrumb bc-3"  >
        <li>
          <a [routerLink]="'/home'">Home</a>
        </li>
        <li>
          <a>Training & Certification</a>
        </li>
        
      </ol>
      <div class="inner-wrapper">
        <div class="sub-wrapper">
          <h3 class="page-title obs-card-title" >
            <span class="page-sub-title">
              <ng-container *ngIf="isUpdate">Course : TNC{{courseId}}
              </ng-container>
              <ng-container *ngIf="courseId === 0">Apply for Training and Certification
              </ng-container>
            </span>
            <button *ngIf="isUpdate" (click)="isNext ? onNextClick() : $event.preventDefault()"
              [ngClass]="isNext ? 'cursor-pointer' : 'disabled'" class="pull-right btn btn-primary primary-btn">
              <i class="fa fa-angle-right"></i>
            </button>
            <button *ngIf="isUpdate" (click)="isPrevious ? onPreviousClick() : $event.preventDefault()"
              [ngClass]="isPrevious ? 'cursor-pointer' : 'disabled'" class="pull-right btn btn-primary primary-btn">
              <i class="fa fa-angle-left"></i></button>
          </h3>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div class="section-wrapper">
              <span class="mandatory-info pull-right">
                Fields marked with
                <span class="mandatory">*</span> are mandatory
              </span>
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div class="sub-section-wrapper">
              <span class="section-title"> Trainee Details </span>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Name of Trainee : <span class="mandatory">*</span></span>
                <p-autoComplete formControlName="TraineeName" [suggestions]="userResults" appendTo="body"
                  (completeMethod)="getUsersOnSearch($event)" (onSelect)="selectUser($event)"
                  (onChange)="selectUser($event)" placeholder="Employee Name" field="FullName" [minLength]="1"
                  [forceSelection]="true">
                  <ng-template let-employee pTemplate="item">
                    <span [title]="employee.Email">{{employee.FullName}}</span>
                  </ng-template>
                </p-autoComplete>
                <span class="error-msg-colour"
                  *ngIf="tncForm.submitted && TNCForm.get('TraineeName').hasError('required')">Please Enter Name of
                  Trainee</span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Unit : <span class="mandatory">*</span></span>
                <input type="text" formControlName="BaseUnit" maxlength="50" value="" class="form-control margin-top-8"
                  placeholder="Select">
                <span class="error-msg-colour"
                  *ngIf="TNCForm.get('TraineeName').value && !TNCForm.get('BaseUnit').value">This data is not
                  available in the system. Please contact admin to update these details</span>
              </div>
              
        <div class="sub-section-wrapper" [hidden]="isEmployee">
          <span class="section-sub-title">Contract Number</span>
          <input type="text" formControlName="ContractNumber" maxlength="50" value=""
          class="form-control margin-top-8" placeholder="Select">
         
        </div>
        
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Designation : <span class="mandatory">*</span></span>
                <input type="text" formControlName="Designation" maxlength="50" value=""
                  class="form-control margin-top-8" placeholder="Select">
                <span class="error-msg-colour"
                  *ngIf="TNCForm.get('TraineeName').value && !TNCForm.get('Designation').value">This data is not
                  available in the system. Please contact admin to update these details</span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">{{UserTypeIDName}}<span class="mandatory">*</span></span>
                <input type="text" formControlName="EmployeeId" maxlength="50" value=""
                  class="form-control margin-top-8" placeholder="Select">
                <span class="error-msg-colour"
                  *ngIf="TNCForm.get('TraineeName').value && !TNCForm.get('EmployeeId').value">This data is not
                  available in the system. Please contact admin to update these details</span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Immediate Supervisor / Manager Name : <span
                  class="mandatory">*</span> </span>
                <input type="text" formControlName="ImmediateSupervisor" maxlength="50" value=""
                  class="form-control margin-top-8" placeholder="Select">
                <span class="error-msg-colour"
                  *ngIf="TNCForm.get('TraineeName').value && !TNCForm.get('ImmediateSupervisor').value">This data is not
                  available in the system. Please contact admin to update these details</span>
              </div>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-title"> Course Details </span>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Mode : <span class="mandatory">*</span> </span>
                <p-dropdown [options]="courseMode" formControlName="Mode" placeholder="Select"
                  [style]="{'width':'100%'}">
                </p-dropdown>
                <span class="error-msg-colour"
                  *ngIf="tncForm.submitted && TNCForm.get('Mode').hasError('required')">Please select Mode </span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Medium of Instruction : <span class="mandatory">*</span></span>
                <p-multiSelect [options]="courseMedium" placeholder="Select" formControlName="MediumOfInstruction"
                  [style]="{'width':'100%'}">
                </p-multiSelect>
                <span class="error-msg-colour"
                  *ngIf="tncForm.submitted && TNCForm.get('MediumOfInstruction').hasError('required')">Please Select
                  Medium </span>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 priorty-section">
            <div class="sub-section-wrapper">
              <span class="section-sub-title">Priority : <span class="mandatory">*</span></span>
              <p-dropdown [options]="coursePriority" formControlName="Priority" (onChange)="setPriority($event)"
                placeholder="Select" [style]="{'width':'100%'}">
              </p-dropdown>
              <span class="error-msg-colour"
                *ngIf="tncForm.submitted && TNCForm.get('Priority').hasError('required')">Please select Priority</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">Course Specification : <span class="mandatory">*</span></span>
              <p-dropdown [options]="courseSpecification" formControlName="Specification"
                (onChange)="setSpecification($event)" placeholder="Select" [style]="{'width':'100%'}">
              </p-dropdown>
              <span class="error-msg-colour"
                *ngIf="tncForm.submitted && TNCForm.get('Specification').hasError('required')">Please select Course
                Specification</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">Title : <span class="mandatory">*</span></span>
              <p-dropdown [options]="courseTitle" formControlName="Title" [filter]="true" (onChange)="getOtherParticularDetails($event)"
                placeholder="Select" [style]="{'width':'100%'}">
              </p-dropdown>
              <span class="error-msg-colour"
                *ngIf="tncForm.submitted && TNCForm.get('Title').hasError('required')">Please Select the Course</span>
              <span class="error-msg-colour"
                *ngIf="!courseTitle.length && TNCForm.get('Priority').value && TNCForm.get('Specification').value">For
                this Specification and Priority no course found. Please contact admin to update these details</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title"> Course Validity (In years) : <span>{{validity}}</span> </span>
            </div>
            <div class="sub-section-wrapper">
              <div class="section-sub-title">Planned Date : <span class="mandatory">*</span></div>
              <div class="clearfix"></div>

              <div class="form-to">
              <span class="section-sub-title"> From
                <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="false"
                  readonlyInput="true" appendTo="body" hideOnDateTimeSelect="true" monthNavigator="true"
                  yearNavigator="true" formControlName="FromDate" yearRange="1950:2100">
                </p-calendar>
                <span class="error-msg-colour"
                  *ngIf="tncForm.submitted && TNCForm.get('FromDate').hasError('required')">Please Enter From
                  Date</span>
              </span>
              <span class="section-sub-title"> To
                <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="false"
                  readonlyInput="true" appendTo="body" hideOnDateTimeSelect="true" formControlName="ToDate"
                  monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
                </p-calendar>
                <span class="error-msg-colour"
                  *ngIf="tncForm.submitted && TNCForm.get('ToDate').hasError('required')">Please Enter To Date</span>
              </span>
            </div>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-title"> Faculty Details </span>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Name of Faculty : </span>
                <input type="text" maxlength="50" formControlName="FacultyName" value=""
                  class="form-control margin-top-8">
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Email ID : </span>
                <input type="email" formControlName="FacultyEmail" class="form-control margin-top-8" email>
                <span class="error-msg-colour"
                  *ngIf="TNCForm.get('FacultyEmail').invalid && TNCForm.get('FacultyEmail').touched">Kindly enter
                  correct email
                  id.</span>
              </div>
            </div>
          </div>
          <div *ngIf="courseId > 0" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div class="sub-section-wrapper">
              <span class="section-title"> Training Status </span>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Status of Training is:<span class="mandatory">*</span> </span><br>
                <label class="radio-inline no-margin-top margin-bottom-10">
                  <input type="radio" (change)="selectTrainingStatus($event,'Complete')" value="Complete"
                    name="TrainingStatus" formControlName="TrainingStatus" id="Complete" />Complete
                </label>
                <label class="radio-inline no-margin-top margin-bottom-10">
                  <input type="radio" (change)="selectTrainingStatus($event,'Not Complete')" value="Not Complete"
                    name="TrainingStatus" formControlName="TrainingStatus" id="Not-Complete" />Not - Complete
                </label>
                <label class="radio-inline no-margin-top margin-bottom-10">
                  <input type="radio" (change)="selectTrainingStatus($event,'Cancel')" value="Cancel"
                    name="TrainingStatus" formControlName="TrainingStatus" id="Cancel" />Cancel
                </label>
                <label class="radio-inline no-margin-top margin-bottom-10">
                  <input type="radio" (change)="selectTrainingStatus($event,'Delete')" value="Delete"
                    name="TrainingStatus" formControlName="TrainingStatus" id="Delete" />Delete
                </label>
              </div>
              <div
                *ngIf="trainingStatus == TrainingsStatus.NotComplete || trainingStatus == TrainingsStatus.Cancel ||trainingStatus == TrainingsStatus.Delete"
                class="sub-section-wrapper">
                <span class="section-sub-title">Remarks:<span class="mandatory">*</span></span>
                <textarea #textArea class="form-control" formControlName="StatusRemark" [maxLength]="1000"></textarea>
              </div>
              <div *ngIf="trainingStatus == TrainingsStatus.Complete" class="sub-section-wrapper">
                <div class="section-sub-title">Completion Date: <span class="mandatory">*</span></div>
                <div class="clearfix"></div>
                <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="false"
                  readonlyInput="true" (onChange)="enableSaveStatusButton($event)" formControlName="CompletionDate" (onSelect)="ChangeExpiry()"
                  appendTo="body" hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true"
                  yearRange="1950:2100">
                </p-calendar>
              </div>

              <div *ngIf="trainingStatus == TrainingsStatus.Complete" class="sub-section-wrapper">
                <span class="section-sub-title">Upload Certificate:<span *ngIf="isCertificateRequired" class="mandatory">*</span></span>
                <ara-file-upload (change)="invalidCertificate = false" [inputFiles]="TrainingCertificateFiles"
                  (onInputFilesUpdatedData)="onInputFilesUpdated($event)" [disabled]="false" [accept]="accept">
                </ara-file-upload>
                <span *ngIf="TrainingCertificateFiles && TrainingCertificateFiles.length > 0">
                  <ara-files-previewer [files]="TrainingCertificateFiles"></ara-files-previewer>
                </span>
                <span class="error-msg-colour"
                *ngIf="TrainingCertificateFiles.length == 0 && (courseStatus == CourseStatus.Complete || courseStatus == CourseStatus.Rejected)">Kindly upload certificate.</span>

                <div *ngIf="invalidCertificate" class="column has-text-centered">
                  <span class="img-row" *ngFor="let image of TrainingCertificateFiles; let i=index">
                    <div *ngIf="image.Filepath">
                      <img class="img-frame" #row (contextmenu)="cm.show(image);selectFile(image.FilePath);"
                        *ngIf="image.FilePath.toLocaleLowerCase().includes('.heif') || image.FilePath.toLocaleLowerCase().includes('.heic') || image.FilePath.toLocaleLowerCase().includes('.png') || image.FilePath.toLocaleLowerCase().includes('.bmp') || image.FilePath.toLocaleLowerCase().includes('.jpg') || image.FilePath.toLocaleLowerCase().includes('.jpeg') || image.FilePath.toLocaleLowerCase().includes('.svg') "
                        [src]="image.FilePath" (click)="downloadFile(image.FilePath);"
                        pTooltip="{{image.FilePath | fileName}}" tooltipPosition="right" alt="preview" />
                      <i *ngIf="image.FilePath.toLocaleLowerCase().includes('.csv') || image.FilePath.toLocaleLowerCase().includes('.pdf') || image.FilePath.toLocaleLowerCase().includes('.docx') || image.FilePath.toLocaleLowerCase().includes('.xlsx') ||  image.FilePath.toLocaleLowerCase().includes('.pptx') ||  image.FilePath.toLocaleLowerCase().includes('.ppt') ||  image.FilePath.toLocaleLowerCase().includes('.xls') || image.FilePath.toLocaleLowerCase().includes('.doc')"
                        class="fa fa-file img-frame" #row1 (contextmenu)="cm.show(image);selectFile(image.FilePath);"
                        (click)="downloadFile(image.FilePath);" pTooltip="{{image.FilePath | fileName}}"
                        tooltipPosition="right" aria-hidden="true"></i>
                    </div>
                  </span>
                </div>
              </div>

              <button type="submit"
                [disabled]="((!isTrainee && !permissions.TNC_Admin && !permissions.TNC_Admin_Unit) || ((!TrainingCertificateFiles.length && isCertificateRequired) && TNCForm.get('TrainingStatus').value == 'Complete') || !TNCForm.get('TrainingStatus').value || ((!TNCForm.get('StatusRemark').value) && (!TNCForm.get('CompletionDate').value)) && (courseStatus != CourseStatus.Inprogress && courseStatus != CourseStatus.TrainingRescheduled)) || !isStatusModified"
                (click)="submitTrainingStatus()" pButton label="Submit" class="active-btn orange-btn button-submit"></button>
            </div>
            <div
              *ngIf="isApprovalSectionShow"
              class="sub-section-wrapper">
              <span class="section-title"> Validation(By Manager/Supervisor) </span>
              <div *ngIf="this.tncRequest.ApprovalDetails.length > 0 && courseStatus !== CourseStatus.PendingForApproval" class="section-sub-title sub-section-wrapper">
                <div>Validator: {{validator}}</div>
                <div>Designation: {{validatorDesignation}}</div>
                <div *ngIf="status == 'Approved'">Approved Date: {{ApprovalDate | dateTimeFormat: "MMM D, YYYY h:mm a"}}</div>
                <div>Status: {{status}}</div>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">I have reviewed the certificate and I am satisfied by training
                  provided to the Trainee.</span>
              </div>
              <div class="sub-section-wrapper">
                <span class="img-row" style="display: inline-flex;width:41%;" *ngFor="let Certificate of TrainingCertificateFiles; let i=index">
                  <input type="button" class="btn btn-primary primary-btn" (click)="downloadFile(Certificate.FilePath);"
                    value="Download Certificate">
                </span>
              </div>
              <div *ngIf="validity!='Lifetime'" class="sub-section-wrapper">
                <div class="section-sub-title">Expiry Date: <span class="mandatory">*</span></div>
                <div class="clearfix"></div>
                <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="false" [maxDate] = "maxExpiryDate"
                  readonlyInput="true" formControlName="ExpiryDate" appendTo="body" hideOnDateTimeSelect="true"
                  monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
                </p-calendar>
              </div>

              <div>
                <input type="button" class="btn btn-primary button-approve" formControlName="btnApprove" (click)="saveApprovals(true)"
                  value="Approve"> &nbsp; 
                <input type="button" class="btn btn-primary button-reject" formControlName="btnReject" (click)="saveApprovals(false)"
                  value="Reject">
                <input placeholder=" Remarks" formControlName="ApprovalRemark" class="margin-left-10" type="text">
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="breaker assign-training-footer"></div>
          <ara-record-actions [SourceId]="courseId" ModuleName="TNC"
            [ShowCancel]="((tncPermissions.TNC_Admin || tncPermissions.TNC_Admin_Unit) && courseStatus !==CourseStatus.Deleted && courseId !== 0) && courseStatus !==CourseStatus.Cancelled"
            [ShowDelete]="independentPermissions.SUPER_Admin && courseId !== 0 && courseStatus !==CourseStatus.Deleted && courseStatus !==CourseStatus.Cancelled" (output)="getOutput($event)">
          </ara-record-actions>
          <footer >
            <button type="button" class="btn btn-primary primary-btn button-draft" (click)="saveAsDraft()"
						*ngIf="(courseId === 0 || courseStatus == CourseStatus.Draft)"
            [disabled]="!TNCForm.get('TraineeName').value || !TNCForm.get('BaseUnit').value || !TNCForm.get('ImmediateSupervisor').value || !TNCForm.get('Designation').value || !TNCForm.get('Mode').value || !TNCForm.get('MediumOfInstruction').value  || !TNCForm.get('Priority').value || !TNCForm.get('Specification').value || !TNCForm.get('Title').value || !TNCForm.get('FromDate').value || !TNCForm.get('ToDate').value">
					  <i class="fa fa-envelope"></i>Save As Draft</button>
            <button type="button"
              *ngIf="isUpdate && isManager || isUpdate && tncPermissions.TNC_Admin || isUpdate && tncPermissions.TNC_Admin_Unit"
              class="btn btn-primary primary-btn button-back-to-user-profile button-back" (click)="toUserProfile()">
              <i class="fa fa-reply"></i>Back to User Profile </button>
            <button type="button" class="btn btn-primary primary-btn button-back button-float-left" routerLink="/tnc/tnc-overview">
              <i class="fa fa-reply"></i>Back to Overview </button>
              <button type="button"
              *ngIf="courseId > 0"
              (click)="ReportshowDialog()"
              class="btn btn-primary primary-btn button-report-log button-float-left"
               >Report Log
              </button> 
            <button type="button" *ngIf="!isUpdate" class="btn btn-primary primary-btn button-reset" (click)="ResetForm()">
              <i class="fa fa-refresh"></i>RESET
            </button>
            <button type="submit"
              *ngIf="!isUpdate &&  !(trainingStatus == TrainingsStatus.NotComplete || trainingStatus == TrainingsStatus.Cancel)"
              (click)="assignTraining()" class="btn btn-primary primary-btn button-submit"
              [disabled]="!TNCForm.get('TraineeName').value || !TNCForm.get('BaseUnit').value || !TNCForm.get('ImmediateSupervisor').value || !TNCForm.get('Designation').value || !TNCForm.get('Mode').value || !TNCForm.get('MediumOfInstruction').value  || !TNCForm.get('Priority').value || !TNCForm.get('Specification').value || !TNCForm.get('Title').value || !TNCForm.get('FromDate').value || !TNCForm.get('ToDate').value">
              <i class="fa fa-share-square"> SUBMIT</i>
            </button>
            <button type="submit"
              *ngIf="isUpdate && (isManager || tncPermissions.TNC_Admin_Unit || tncPermissions.TNC_Admin) && courseStatus == CourseStatus.Inprogress || ((tncPermissions.TNC_Admin_Unit || tncPermissions.TNC_Admin) && courseStatus != CourseStatus.Draft)"
              (click)="assignTraining()" class="btn btn-primary primary-btn button-update"
              [disabled]=" !TNCForm.get('Mode').value || !TNCForm.get('MediumOfInstruction').value  || !TNCForm.get('Priority').value || !TNCForm.get('Specification').value || !TNCForm.get('Title').value || !TNCForm.get('FromDate').value || !TNCForm.get('ToDate').value ||((courseStatus == CourseStatus.Complete || courseStatus == CourseStatus.Rejected) && (TrainingCertificateFiles == undefined || TrainingCertificateFiles == null || TrainingCertificateFiles.length == 0 ))">
              <i class="fa fa-share-square"> Update</i>
            </button>
            <button type="button" class="btn btn-primary primary-btn button-submit" (click)="assignTraining()"
						*ngIf="(courseStatus == CourseStatus.Draft)"
            [disabled]="!TNCForm.get('TraineeName').value || !TNCForm.get('BaseUnit').value || !TNCForm.get('ImmediateSupervisor').value || !TNCForm.get('Designation').value || !TNCForm.get('Mode').value || !TNCForm.get('MediumOfInstruction').value  || !TNCForm.get('Priority').value || !TNCForm.get('Specification').value || !TNCForm.get('Title').value || !TNCForm.get('FromDate').value || !TNCForm.get('ToDate').value">
					  <i class="fa fa-envelope"></i>SUBMIT</button>
            <button type="button" class="btn btn-primary primary-btn button-reschedule" (click)='reScheduleTraining()'
              *ngIf="isUpdate && (isManager || tncPermissions.TNC_Admin_Unit || tncPermissions.TNC_Admin) && (trainingStatus == TrainingsStatus.NotComplete || trainingStatus == TrainingsStatus.Cancel)">
              <i class="fa fa-share-square"></i>RESCHEDULE
            </button>
          </footer>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
  <div class="clearfix"></div>
</form>

<ara-alerts [alertType]="alertType" [successDetails]="successDetails" [errorDetails]="errorDetails"
  (okClicked)="onOkClickedForConfirmation()" [confirmMessage]="confirmMessage"
  (yesClicked)="onYesClickedForConfirmation()" (noClicked)="onNoClickedForConfirmation()"></ara-alerts>
<div class="clearfix"></div>

<span *ngIf="ReportclosePopup">
  <p-dialog header="Report History" [(visible)]="ReportclosePopup" (onHide)="ReportclosePopUp()" [modal]="true">
   <ara-report-log [ReportUserId]="ReportUserId" [ReportModule]="ReportModule"
     [ReportRecordId]="ReportRecordId">
   </ara-report-log>
 </p-dialog> 
</span>
